import { lazy } from 'react';

/** Загружает страницу функциональных переключателей */
export const FeatureTogglesPageAsync = lazy(() => import('./FeatureTogglesPage'));
